/* ENSO Set Offer - product page "complete the set". Symmetry 8.x. 2026-10-11 */
(function () {
  if (customElements.get('enso-set-offer')) return;

  const reduceMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    const match = fmt.match(placeholderRegex);
    let value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  function tpl(str, vars) { return String(str || '').replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m)); }
  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach((k) => {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (attrs[k] != null && attrs[k] !== false) node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach((c) => { if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return node;
  }

  class EnsoSetOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      try {
        this.partners = JSON.parse(this.querySelector('[data-eso-partners]').textContent);
        this.main = JSON.parse(this.querySelector('[data-eso-main]').textContent);
        this.t = JSON.parse(this.querySelector('[data-eso-strings]').textContent);
      } catch (e) { console.error('[ENSO set offer] bad JSON', e); return; }
      if (!this.partners.length) return;

      this.mainColorOpt = parseInt(this.dataset.mainColorOption, 10) || 0;
      this.mainSizeOpt = parseInt(this.dataset.mainSizeOption, 10) || 0;
      this.percent = parseFloat(this.dataset.percent) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.cartAddUrl = this.dataset.cartAdd || '/cart/add.js';
      this.lowStock = parseInt(this.dataset.lowStock, 10) || 0;
      this.section = this.closest('.shopify-section') || document;

      this.r = {
        eyebrow: this.querySelector('[data-eso-eyebrow]'), badge: this.querySelector('[data-eso-badge]'),
        lead: this.querySelector('[data-eso-lead]'), partnersWrap: this.querySelector('[data-eso-partners-wrap]'),
        piece: this.querySelector('[data-eso-piece]'), link: this.querySelector('[data-eso-link]'), img: this.querySelector('[data-eso-img]'),
        name: this.querySelector('[data-eso-name]'), price: this.querySelector('[data-eso-price]'),
        sizeLabel: this.querySelector('[data-eso-size-label]'), sizeNote: this.querySelector('[data-eso-size-note]'), pills: this.querySelector('[data-eso-pills]'),
        note: this.querySelector('[data-eso-note]'), add: this.querySelector('[data-eso-add]'), addLabel: this.querySelector('[data-eso-add-label]'),
        was: this.querySelector('[data-eso-was]'), now: this.querySelector('[data-eso-now]'), saves: this.querySelector('[data-eso-saves]'), error: this.querySelector('[data-eso-error]')
      };
      this.r.eyebrow.textContent = this.t.eyebrow;
      this.r.badge.textContent = tpl(this.t.save, { percent: this.percent });
      this.r.sizeLabel.textContent = this.t.size;

      this.state = { mainVariant: null, colour: null, mainSize: null, partnerId: null, partnerVariantId: null, sizeTouched: false };
      this.readMainVariant();
      this.bind();
      this.render();
    }

    /* ---------- main product ---------- */

    currentMainVariantId() {
      const input = this.section.querySelector('.js-product-form input[name="id"]');
      const id = input && parseInt(input.value, 10);
      return id || null;
    }

    readMainVariant(variantFromEvent, selectedOptions) {
      let v = variantFromEvent || null;
      if (!v) {
        const id = this.currentMainVariantId();
        v = id ? this.main.variants.find((x) => x.id === id) : null;
        if (!v) {
          const dataEl = this.section.querySelector('variant-picker [type="application/json"]');
          try { const j = dataEl ? JSON.parse(dataEl.textContent) : null; if (j && j.id) v = this.main.variants.find((x) => x.id === j.id) || { id: j.id, price: j.price, available: j.available, options: j.options }; } catch (e) { v = null; }
        }
      } else if (!v.options && v.option1) {
        v.options = [v.option1, v.option2, v.option3].filter((x) => x != null);
      }
      this.state.mainVariant = v;
      // Partial selection (colour picked, size not yet): follow the colour straight away
      let opts = v && v.options ? v.options : [];
      if (!v && Array.isArray(selectedOptions)) opts = selectedOptions;
      if (!v && !opts.length) opts = this.readPickerSelection();
      const newColour = this.mainColorOpt > 0 ? (opts[this.mainColorOpt - 1] || null) : null;
      const newSize = this.mainSizeOpt > 0 ? (opts[this.mainSizeOpt - 1] || null) : null;
      const colourChanged = newColour !== this.state.colour;
      const sizeChanged = newSize !== this.state.mainSize;
      this.state.colour = newColour;
      this.state.mainSize = newSize;
      if (colourChanged) this.state.partnerVariantId = null;
      if (sizeChanged && !this.state.sizeTouched) this.state.partnerVariantId = null;
    }

    readPickerSelection() {
      const picker = this.section.querySelector('variant-picker');
      if (!picker) return [];
      try { if (typeof picker.getSelectedOptions === 'function') return picker.getSelectedOptions(); } catch (e) { /* no-op */ }
      return [];
    }

    /* ---------- partner helpers ---------- */

    hasColour(p, colour) { return p.colorOption > 0 && p.colors.some((c) => c.name === colour); }
    availableIn(p, colour) { return p.variants.some((v) => (p.colorOption === 0 || v.color === colour) && v.available); }
    imageFor(p, colour) { const c = p.colors.find((x) => x.name === colour); return (c && c.image) || p.image; }
    variantFor(p, colour, size) { return p.variants.find((v) => (p.colorOption === 0 || v.color === colour) && (p.sizeOption === 0 || v.size === size)) || null; }

    eligiblePartners() {
      const colour = this.state.colour;
      return this.partners.filter((p) => p.colorOption === 0 || !colour || this.hasColour(p, colour));
    }

    currentPartner() {
      const list = this.eligiblePartners();
      if (!list.length) return null;
      let p = this.state.partnerId ? list.find((x) => x.id === this.state.partnerId) : null;
      if (!p) p = list.find((x) => this.availableIn(x, this.state.colour)) || list[0];
      this.state.partnerId = p.id;
      return p;
    }

    /* ---------- render ---------- */

    render() {
      const colour = this.state.colour;
      const partner = this.currentPartner();
      const r = this.r;
      if (!partner || (colour && !this.hasColour(partner, colour))) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      // partner chooser (only when more than one piece exists in this colour)
      const list = this.eligiblePartners();
      r.partnersWrap.innerHTML = '';
      if (list.length > 1) {
        r.partnersWrap.hidden = false;
        list.forEach((p) => {
          const avail = this.availableIn(p, colour);
          r.partnersWrap.appendChild(el('button', {
            type: 'button', class: 'eso__chip', role: 'radio', 'aria-checked': p.id === partner.id ? 'true' : 'false', 'data-partner': p.id, disabled: !avail
          }, [el('img', { src: this.imageFor(p, colour), alt: '', width: 36, height: 48, loading: 'lazy' }), el('span', { text: p.shortTitle })]));
        });
      } else {
        r.partnersWrap.hidden = true;
      }

      // piece
      const noColour = this.mainColorOpt > 0 && !colour;
      const soldOut = !noColour && !this.availableIn(partner, colour);
      r.lead.textContent = noColour ? tpl(this.t.pickColour, { piece: partner.shortTitle }) : tpl(this.t.withThe, { piece: partner.shortTitle, colour: colour || '' });
      r.link.href = partner.url;
      const img = this.imageFor(partner, colour);
      if (img && r.img.getAttribute('src') !== img) { r.img.classList.remove('is-in'); r.img.src = img; r.img.onload = () => r.img.classList.add('is-in'); if (r.img.complete) r.img.classList.add('is-in'); }
      r.name.textContent = partner.shortTitle;
      const price = Math.min.apply(null, partner.variants.map((v) => v.price));
      r.price.textContent = formatMoney(price, this.moneyFormat);

      // sizes: default to the size chosen for the main piece
      r.pills.innerHTML = '';
      r.sizeNote.textContent = '';
      let chosen = this.state.partnerVariantId ? partner.variants.find((v) => v.id === this.state.partnerVariantId) : null;
      if (!chosen && partner.sizeOption > 0 && this.state.mainSize && !this.state.sizeTouched) {
        const same = this.variantFor(partner, colour, this.state.mainSize);
        if (same && same.available) { chosen = same; this.state.partnerVariantId = same.id; }
      }
      if (!chosen && partner.sizeOption === 0) {
        const only = this.variantFor(partner, colour, null);
        if (only && only.available) { chosen = only; this.state.partnerVariantId = only.id; }
      }
      this.querySelector('.eso__sizes').hidden = noColour;
      if (partner.sizeOption > 0 && !noColour) {
        partner.sizes.forEach((size) => {
          const v = this.variantFor(partner, colour, size);
          const available = !!(v && v.available);
          const low = available && v.managed && this.lowStock > 0 && v.qty > 0 && v.qty <= this.lowStock;
          r.pills.appendChild(el('button', {
            type: 'button', class: 'eso__pill', role: 'radio', 'data-size': size, 'aria-checked': chosen && v && chosen.id === v.id ? 'true' : 'false', disabled: !available
          }, [el('span', { text: size }), low ? el('small', { text: tpl(this.t.left, { n: v.qty }) }) : null]));
        });
        if (chosen && !this.state.sizeTouched && this.state.mainSize && chosen.size === this.state.mainSize) {
          r.sizeNote.textContent = tpl(this.t.sameSize, { main: this.main.shortTitle });
        }
      }
      r.piece.classList.toggle('is-soldout', soldOut);

      // totals and button
      const mainV = this.state.mainVariant;
      const mainOk = !!(mainV && mainV.available !== false);
      r.note.hidden = true;
      r.saves.hidden = true;
      r.error.hidden = true;
      r.was.textContent = ''; r.now.textContent = '';
      if (soldOut) {
        r.note.textContent = tpl(this.t.soldOutIn, { piece: partner.shortTitle, colour: colour || '' });
        r.note.hidden = false;
        r.add.hidden = true;
        return;
      }
      r.add.hidden = false;
      if (noColour) {
        r.addLabel.textContent = this.t.chooseColour;
        r.add.setAttribute('aria-disabled', 'true');
        return;
      }
      if (!mainOk) {
        r.addLabel.textContent = this.t.chooseMain;
        r.add.setAttribute('aria-disabled', 'true');
        return;
      }
      if (!chosen) {
        r.addLabel.textContent = tpl(this.t.choosePartnerSize, { piece: partner.shortTitle });
        r.add.setAttribute('aria-disabled', 'true');
        return;
      }
      const subtotal = (mainV.price || this.main.price) + chosen.price;
      const discount = Math.round(subtotal * this.percent / 100);
      r.addLabel.textContent = this.t.addBoth;
      r.was.textContent = formatMoney(subtotal, this.moneyFormat);
      r.now.textContent = formatMoney(subtotal - discount, this.moneyFormat);
      r.saves.textContent = tpl(this.t.saves, { amount: formatMoney(discount, this.moneyFormat) });
      r.saves.hidden = false;
      r.add.setAttribute('aria-disabled', 'false');
    }

    /* ---------- events ---------- */

    bind() {
      this.addEventListener('click', (e) => {
        const chip = e.target.closest('.eso__chip');
        if (chip && !chip.disabled) { this.state.partnerId = parseInt(chip.dataset.partner, 10); this.state.partnerVariantId = null; this.state.sizeTouched = false; this.haptic(); this.render(); return; }
        const pill = e.target.closest('.eso__pill');
        if (pill && !pill.disabled) {
          const partner = this.currentPartner();
          const v = this.variantFor(partner, this.state.colour, pill.dataset.size);
          if (v && v.available) { this.state.partnerVariantId = v.id; this.state.sizeTouched = true; this.haptic(); this.render(); }
          return;
        }
        if (e.target.closest('[data-eso-add]')) {
          if (this.r.add.getAttribute('aria-disabled') === 'true') {
            if (!this.state.mainVariant || !this.state.colour) { const picker = this.section.querySelector('variant-picker'); if (picker) picker.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' }); }
            return;
          }
          this.addBoth();
        }
      });

      // Symmetry announces every variant change from the main product form
      this.onVariantChange = (e) => {
        if (!e.target || !this.section.contains(e.target)) return;
        this.readMainVariant(e.detail && e.detail.variant ? e.detail.variant : null, e.detail && e.detail.selectedOptions);
        this.render();
      };
      document.addEventListener('on:variant:change', this.onVariantChange);
      // Fallback: the hidden id input is updated in place on every change
      const idInput = this.section.querySelector('.js-product-form input[name="id"]');
      if (idInput) idInput.addEventListener('change', () => { this.readMainVariant(); this.render(); });
      const picker = this.section.querySelector('variant-picker');
      if (picker) picker.addEventListener('change', () => { setTimeout(() => { this.readMainVariant(); this.render(); }, 30); });
    }

    disconnectedCallback() { if (this.onVariantChange) document.removeEventListener('on:variant:change', this.onVariantChange); }

    haptic() { try { if (navigator.vibrate && window.matchMedia('(max-width: 989px)').matches) navigator.vibrate(6); } catch (e) { /* no-op */ } }

    async addBoth() {
      const r = this.r;
      if (r.add.classList.contains('is-loading')) return;
      const mainId = this.currentMainVariantId() || (this.state.mainVariant && this.state.mainVariant.id);
      if (!mainId || !this.state.partnerVariantId) return;
      const setId = 'set-' + Date.now().toString(36);
      const items = [
        { id: mainId, quantity: 1, properties: { _enso_set: setId } },
        { id: this.state.partnerVariantId, quantity: 1, properties: { _enso_set: setId } }
      ];
      const header = document.querySelector('page-header');
      const drawer = document.querySelector('cart-drawer');
      const targets = [header, drawer].filter((x) => x && x.dataset.sectionId);
      const body = { items };
      if (targets.length) { body.sections = targets.map((x) => x.dataset.sectionId).join(','); body.sections_url = window.location.pathname; }

      r.add.classList.add('is-loading'); r.add.setAttribute('aria-busy', 'true'); r.error.hidden = true;
      try {
        const res = await fetch(this.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok) { const msg = data.description || data.message || this.t.error; throw new Error(typeof msg === 'string' ? msg : this.t.error); }
        const after = (window.theme && theme.settings && theme.settings.afterAddToCart) || 'drawer';
        if (after === 'page' || after === 'no-js') { window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart'; return; }
        if (data.sections && targets.length && Object.keys(data.sections).length === targets.length) {
          targets.forEach((x) => { if (x.updateFromCartChange) x.updateFromCartChange(data.sections[x.dataset.sectionId]); });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
        if (drawer && typeof drawer.open === 'function') setTimeout(() => drawer.open(r.add), 350);
        else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: r.add } }));
        (data.items || []).forEach((it) => document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: it.variant_id } })));
        r.add.classList.remove('is-loading'); r.add.classList.add('is-success');
        const label = r.addLabel.textContent; r.addLabel.textContent = this.t.added;
        this.haptic();
        setTimeout(() => { r.add.classList.remove('is-success'); r.add.removeAttribute('aria-busy'); r.addLabel.textContent = label; }, 2200);
      } catch (err) {
        r.add.classList.remove('is-loading'); r.add.removeAttribute('aria-busy');
        r.error.textContent = err.message || this.t.error; r.error.hidden = false;
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
    }
  }

  customElements.define('enso-set-offer', EnsoSetOffer);
})();
